/**
 * Formats contact method identifiers into user-friendly display names
 * @param method - The technical method identifier from the backend
 * @returns User-friendly display name
 */
export function formatContactMethod(method: string): string {
  const methodMap: Record<string, string> = {
    'survey/link/sms/twilio': 'Survey/SMS',
    'survey': 'Survey/SMS',
    // PHA-1261: response filled in by staff from a "Show survey link" tab.
    'staff_entry': 'Entered by care team',
    'voice call/retell': 'Voice Call',
    'ad-hoc questions to patient': 'Voice Call Survey',
  };

  return methodMap[method] || method;
}

/**
 * PHA-1010: renders a stored clinic phone number the way a patient will read it in an SMS.
 *
 * Clinic numbers are stored as either 10 digits or E.164 (the admin form accepts both), so
 * the raw value can read as `2125551234`. Mirrors `_format_phone_for_display` in
 * app_logic.py so the preview in the settings form matches the message actually sent.
 * A non-US or unparseable value is returned unchanged rather than mangled.
 */
export function formatPhoneForDisplay(phone?: string | null): string {
  const raw = String(phone ?? '').trim();
  let digits = raw.replace(/[^0-9]/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return raw;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
